RivalIQ.apps.Admin.module('models', function (models, Admin, Backbone, Marionette, $, _, moment, CompareData) {

    'use strict';

    models.Company = Backbone.Model.extend({
        urlRoot: '/admin/api/companies',

        toJSON: function () {
            const me = this;
            const custom = {};

            if (me.attributes.finderFlags) {
                custom.channel_finder_flags = RivalIQ.utils.channelFinderFlags.convertObjectToBitfield(me.attributes.finderFlags);
            }

            if (me.attributes.changeRequests) {
                custom.changeRequests = _.map(me.attributes.changeRequests.toJSON(), function (req) {
                    return _.pick(req, 'id', 'completed');
                });
            }

            if (me.attributes.urls) {
                custom.urls = _.map(me.attributes.urls.toJSON(), function (url) {
                    return _.pick(url, 'id', 'is_primary', 'page_type_id');
                });
            }

            return _.extend({}, me.attributes, custom);
        },

        // Clear out the junk, only send what we need to
        toAjaxJSON: function () {
            const me = this;
            const data = me.toJSON();

            data.socialChannels = data.socialChannels.map(function (channel) {
                return {
                    source: channel.get('source'),
                    handles: channel.get('handles')
                };
            });

            return _.omit(data, 'channel_discovery_data', 'rollup_data_v2', 'rollup_data_v2_recent');
        },

        // Here is where we turn what we get into what we want.
        // Open question whether this is the best place to be constructing the
        // nested collections / models. Done here for now because
        // passing data between the models became complex when each
        // model created its own collections
        parse: function (data) {

            const finderFlags = data.finderFlags = RivalIQ.utils.channelFinderFlags.convertBitfieldToObject(data.channel_finder_flags);

            _.each(data.socialChannels, function (channel) {
                const details = CompareData.sourceDetails[channel.source];
                const discoveryData = _.get(data, ['channel_discovery_data', details.channel], null);

                channel.id = details.channel;
                channel.finderFlag = finderFlags[details.channel];

                let finderPicked = null;
                if (discoveryData && discoveryData.picked) {
                    finderPicked = discoveryData.picked;
                    finderPicked.source = channel.source;
                }

                const discoveries = discoveryData ? discoveryData.seen : [];
                _.each(discoveries, function (handle) {
                    handle.channel = details.channel;
                    handle.source = channel.source;
                    handle.finderPicked = null;
                    if (finderPicked && handle.native_id === finderPicked.native_id) {
                        handle.finderPicked = finderPicked;
                    }
                });
                channel.discoveries = new RivalIQ.collections.SocialHandles(discoveries);

                _.each(channel.handles, function (handle) {
                    handle.channel = details.channel;
                    handle.source = channel.source;
                    handle.finderPicked = null;
                    if (finderPicked && handle.native_id === finderPicked.native_id) {
                        handle.finderPicked = finderPicked;
                    }
                });

                channel.handles = new RivalIQ.collections.SocialHandles(channel.handles);
            });

            data.socialChannels = new RivalIQ.collections.SocialChannels(data.socialChannels);

            return data;
        },

        lock: function () {
            const me = this;

            const options = {
                url: `${me.url()}/lock`
            };

            return (me.sync || Backbone.sync).call(me, 'create', me, options);
        },

        unlock: function () {
            const me = this;

            const options = {
                url: `${me.url()}/lock`
            };

            return (me.sync || Backbone.sync).call(me, 'delete', me, options);
        },

        updateExternalData: function () {
            const me = this;

            const options = {
                url: `${me.url()}/externalData`
            };

            return (me.sync || Backbone.sync).call(me, 'create', me, options);
        },

        findChannels: function () {
            const me = this;

            const options = {
                url: `${me.url()}/channels`
            };

            return (me.sync || Backbone.sync).call(me, 'create', me, options);
        }

    });

}, window.moment, RivalIQ.data.CompareData);
